import { useClipboard, Stack, Button, Link } from "@chakra-ui/react";
import { Copy, Envelope, SocialFacebook, SocialTwitter, Messenger, WhatsApp } from "@airhelp/icons";
import type { SocialLinksPanelProps } from "./SocialLinksPanel.d";
import { buttonStyles, iconStyles, linkStyles } from "./SocialLinksPanel.styles";

const SocialLinksPanel = ({
  copyButton = true,
  direction = "row",
  spacing = 4,
  url,
  title = "",
  buttonSize = "m",
  ...props
}: SocialLinksPanelProps) => {
  const { onCopy } = useClipboard(url);

  return (
    <Stack direction={direction} wrap="wrap" gap={spacing} justifyContent="center" {...props}>
      <Link href={`https://www.facebook.com/sharer.php?u=${url}`} isExternal>
        <Button
          {...buttonStyles}
          size={buttonSize}
          bg="#4267B2"
          _hover={{ bg: "#395999" }}
          _active={{ bg: "#2F4A80" }}
          aria-label="Facebook"
        >
          <SocialFacebook {...iconStyles} />
        </Button>
      </Link>
      <Link
        href={`fb-messenger://share/?link=${url}`}
        isExternal
        display={{ base: "initial", md: "none" }}
        {...linkStyles}
      >
        <Button
          {...buttonStyles}
          size={buttonSize}
          bg="#006AFF"
          _hover={{ bg: "#005FE5" }}
          _active={{ bg: "#0055CC" }}
          aria-label="Facebook Messenger"
        >
          <Messenger {...iconStyles} />
        </Button>
      </Link>
      <Link href={`https://api.whatsapp.com/send/?text=${url}`} isExternal {...linkStyles}>
        <Button
          {...buttonStyles}
          size={buttonSize}
          bg="#25D366"
          _hover={{ bg: "#21BA5B" }}
          _active={{ bg: "#188741" }}
          aria-label="WhatsApp"
        >
          <WhatsApp {...iconStyles} />
        </Button>
      </Link>

      <Link href={`https://twitter.com/share?text=${title}&url=${url}&via=theairhelper`} isExternal {...linkStyles}>
        <Button
          {...buttonStyles}
          size={buttonSize}
          bg="#000000"
          _hover={{ bg: "#333333" }}
          _active={{ bg: "#555555" }}
          aria-label="Twitter"
        >
          <SocialTwitter {...iconStyles} />
        </Button>
      </Link>
      <Link href={`mailto:?body=${url}`} isExternal {...linkStyles}>
        <Button {...buttonStyles} size={buttonSize} aria-label="E-mail">
          <Envelope {...iconStyles} />
        </Button>
      </Link>
      {copyButton && (
        <Button {...linkStyles} {...buttonStyles} size={buttonSize} onClick={onCopy} aria-label="Copy">
          <Copy {...iconStyles} />
        </Button>
      )}
    </Stack>
  );
};

export default SocialLinksPanel;
